import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '@redshelf/redshelf-ui';

import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      ...theme.typography.body1,
      color: theme.palette.greyBlue[700],
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
    },
    label: {
      marginRight: theme.spacing(1),
    },
  };
});

const SelectAllBanner = ({
  totalCount,
  selectedCount,
  label = '',
  onClick,
  ...props
}) => {
  const classes = useStyles();
  const isAllSelected = selectedCount === totalCount;

  return (
    <div className={classes.root} {...props}>
      {isAllSelected ? (
        <span className={classes.label}>
          All <strong>{totalCount}</strong> {label} are selected.
        </span>
      ) : (
        <span className={classes.label}>
          <strong>{selectedCount}</strong> of <strong>{totalCount}</strong>{' '}
          {label} selected.
        </span>
      )}
      <Button onClick={onClick} variant="secondary" size="small">
        {isAllSelected
          ? 'Clear Selection'
          : `Select all ${totalCount} ${label}`}
      </Button>
    </div>
  );
};

SelectAllBanner.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
};

SelectAllBanner.defaultProps = {};

export default SelectAllBanner;
